module.exports = __webpack_public_path__ + "img/ic_people.384e8531.svg";